// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_BuscadadosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /mensagens_programadas_lote/buscaDados
 * Returns list of bulk scheduled message operations
 */
import type { MensagensProgramadasLote_BuscadadosItemRow } from './MensagensProgramadasLote_BuscadadosItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MensagensProgramadasLote_BuscadadosResponseDados = MensagensProgramadasLote_BuscadadosItemRow[];

export type MensagensProgramadasLote_BuscadadosResponse = ApiResponse<MensagensProgramadasLote_BuscadadosResponseDados>;

registerResponseContract('MensagensProgramadasLote_BuscadadosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:                  { type: 'number',  required: true },
      status:              { type: 'string',  required: false },
      status_label:        { type: 'string',  required: false },
      periodo_inicio:      { type: 'string',  required: false },
      periodo_fim:         { type: 'string',  required: false },
      franquias:           { type: 'array',   required: false },
      template_id:         { type: 'number',  required: false },
      quantidade_clientes: { type: 'number',  required: false },
      data_criacao:        { type: 'string',  required: false },
      usuario_id:          { type: 'number',  required: false },
      usuario_nome:        { type: 'string',  required: false },
      template_nome:       { type: 'string',  required: false },
    },
  },
})
